var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.7578C1 6.40654 6.14873 1.25781 12.5 1.25781C18.8513 1.25781 24 6.40654 24 12.7578C24 19.1091 18.8513 24.2578 12.5 24.2578C6.14873 24.2578 1 19.1091 1 12.7578Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.7578C1 6.40654 6.14873 1.25781 12.5 1.25781C18.8513 1.25781 24 6.40654 24 12.7578C24 19.1091 18.8513 24.2578 12.5 24.2578C6.14873 24.2578 1 19.1091 1 12.7578Z",
    stroke: "#DAE4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8332 8.53766L19.2766 9.0942L10.9775 17.3508L10.4242 17.904L9.87097 17.3508L5.72305 13.2225L5.1665 12.6692L6.27633 11.5561L6.83287 12.1094L10.4242 15.6844L18.1668 7.97783L18.7233 7.42456L19.8332 8.53766Z",
    fill: "#1E2129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.85816dcd00f877463173d976676d4f2c.svg";
export { ForwardRef as ReactComponent };